module.exports = __webpack_public_path__ + "static/media/TextEnrichesBadOptimized.16114880.webp";